export default __webpack_public_path__ + "static/media/terraformBadge.e9e11e12.png";